module.exports = __webpack_public_path__ + "img/life-page4-img-3.c2d2a5cd.jpg";